import React, { Suspense, lazy } from 'react';
import Fallback from '../Fallback';

const width = 600;
const height = 200;

const DashboardActivityChart = lazy(() =>
  import('../../components/dashboard/DashboardActivityChart')
);

export default function LazyDashboardActivityChart({__placeholder_html__, ...props}) {
  return (
    <Suspense
      fallback={<Fallback __placeholder_html__={__placeholder_html__} />}
    >
      <DashboardActivityChart width={width} height={height} {...props} />
    </Suspense>
  );
}
